// extracted by mini-css-extract-plugin
export var copyWrapperStyle = "values_item-module--copyWrapperStyle--y4xQk";
export var imageWrapperStyle = "values_item-module--imageWrapperStyle--aIxyO";
export var isFullWidth = "values_item-module--isFullWidth--motFr";
export var isReversedStyle = "values_item-module--isReversedStyle--zKxUZ";
export var valuesItemStyle = "values_item-module--valuesItemStyle--s9tI-";